<div class="tia-console" [class.dark]="isDark">
  
  <!-- ══════════════════════════════════════════════════════════════════════════
       CONSOLE FRAME
  ═══════════════════════════════════════════════════════════════════════════ -->
  <div class="tia-frame">
    
    <!-- Status LEDs -->
    <div class="tia-status-bar">
      <span class="tia-led tia-led--green"></span>
      <span class="tia-led tia-led--yellow"></span>
      <span class="tia-led tia-led--red"></span>
      <span class="tia-status-label">
        <fa-icon [icon]="faUsers" class="me-1"></fa-icon>
        TEAM SELECTOR
      </span>
    </div>

    <!-- Main Screen -->
    <div class="tia-screen">
      
      <!-- Scanline Effect -->
      <div class="tia-scanlines"></div>

      <!-- Content -->
      <div class="tia-content">
        
        <mat-form-field class="tia-field">
          <mat-select
            #singleSelect
            class="tia-select"
            [required]="required"
            [formControl]="teamCtrl"
            [placeholder]="placeholder | translate"
            [panelClass]="isDark ? 'tia-panel-dark' : 'tia-panel-light'"
          >
            <!-- Search Option -->
            <mat-option class="tia-search-option">
              <ngx-mat-select-search 
                [formControl]="teamsFilterCtrl" 
                [placeholderLabel]="placeholderLabel | translate"
                class="tia-search-input"
              >
                <mat-icon ngxMatSelectSearchClear *ngIf="!isFinding" class="tia-search-clear">close</mat-icon>
                <mat-icon ngxMatSelectSearchClear *ngIf="isFinding" class="tia-search-loading">
                  <mat-progress-spinner matSuffix mode="indeterminate" diameter="23"></mat-progress-spinner>
                </mat-icon>
              </ngx-mat-select-search>
            </mat-option>

            <!-- All Teams Option -->
            <mat-option 
              [value]="allOptionValue" 
              *ngIf="allOptionValue && allOptionTitle"
              class="tia-option tia-option--all"
            >
              <div class="tia-option-content">
                <div class="tia-option-icon tia-option-icon--all">
                  <fa-icon [icon]="faUsers"></fa-icon>
                </div>
                <span class="tia-option-text">{{ allOptionTitle | translate }}</span>
              </div>
            </mat-option>

            <!-- Team Options -->
            <mat-option 
              *ngFor="let team of filteredTeams | async; trackBy: trackItem" 
              [value]="team"
              class="tia-option"
            >
              <div class="tia-option-content">
                <div class="tia-option-avatar" *ngIf="team?.icon">
                  <div class="tia-avatar-glow"></div>
                  <app-s3-image [image]="team?.icon"></app-s3-image>
                </div>
                <div class="tia-option-info">
                  <span class="tia-option-name">{{ team?.name }}</span>
                  <span class="tia-option-lead">({{ team.teamLead.username }})</span>
                </div>
              </div>
            </mat-option>
          </mat-select>

          <!-- Clear Button -->
          <button
            mat-button
            *ngIf="teamCtrl.value"
            matSuffix
            mat-icon-button
            class="tia-clear-btn"
            [attr.aria-label]="'BUTTON.CLEAR' | translate"
            (click)="resetTeam($event)"
          >
            <mat-icon>close</mat-icon>
          </button>

          <!-- Hint -->
          <mat-hint *ngIf="hint" class="tia-hint">{{ hint | translate }}</mat-hint>
          
          <!-- Error -->
          <mat-error *ngIf="errorLabel" class="tia-error">{{ errorLabel | translate }}</mat-error>
        </mat-form-field>

      </div>

    </div>

    <!-- Loading Bar -->
    <div class="tia-loading-bar" *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate" class="tia-progress"></mat-progress-bar>
    </div>

  </div>

</div>
